import React, { FunctionComponent } from "react";

const IconAmenities: FunctionComponent<IconAmenitiesProps> = ({
  className,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.86012 3.91839C10.5337 1.84544 13.4663 1.84544 14.1399 3.91839L15.2985 7.48419C15.3989 7.7932 15.6868 8.00242 16.0118 8.00242H19.7611C21.9407 8.00242 22.8469 10.7916 21.0836 12.0727L18.0503 14.2765C17.7875 14.4675 17.6775 14.806 17.7779 15.115L18.9365 18.6808C19.61 20.7538 17.2374 22.4775 15.4741 21.1964L12.4408 18.9926C12.178 18.8016 11.822 18.8016 11.5592 18.9926L8.52591 21.1964C6.76256 22.4775 4.38997 20.7538 5.06352 18.6808L6.22212 15.115C6.32252 14.806 6.21253 14.4675 5.94966 14.2765L2.91642 12.0727C1.15306 10.7916 2.0593 8.00242 4.23893 8.00242H7.98823C8.31315 8.00242 8.60112 7.7932 8.70152 7.48419L9.86012 3.91839ZM12.7133 4.38191C12.4888 3.69093 11.5112 3.69093 11.2867 4.38192L10.1281 7.94771C9.82689 8.87476 8.96299 9.50242 7.98823 9.50242H4.23893C3.51239 9.50242 3.21031 10.4321 3.79809 10.8592L6.83134 13.063C7.61994 13.6359 7.94992 14.6515 7.6487 15.5785L6.4901 19.1443C6.26559 19.8353 7.05645 20.4099 7.64423 19.9829L10.6775 17.7791C11.4661 17.2061 12.5339 17.2061 13.3225 17.7791L16.3558 19.9829C16.9435 20.4099 17.7344 19.8353 17.5099 19.1443L16.3513 15.5785C16.0501 14.6515 16.3801 13.6359 17.1687 13.063L20.2019 10.8592C20.7897 10.4321 20.4876 9.50242 19.7611 9.50242H16.0118C15.037 9.50242 14.1731 8.87476 13.8719 7.94771L12.7133 4.38191Z"
        fill="currentColor"
      />
    </svg>
  );
};

export type IconAmenitiesProps = {
  className?: string;
};

export default React.memo(IconAmenities);
